<template>
  <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}">
    <div class="message"
      :style="{
      'background': speaker==='my' ? color.balloonMy : color.balloonOtr + '!important', 
      'color': autoColor(speaker==='my' ? color.balloonMy : color.balloonOtr),
      'filter': shadowStyle(color.shadowType)}"
    >
      <div v-if="message.split('|').length==1">
        <p class="message-title">日付をお選びください。</p>
        <div style="height: 330px; width: 280px; transform: scale(0.9); display: flex; justify-content: center;">
          <transition name="fade">
            <b-datepicker
              v-if="isCalenderDisplayed"
              v-model="date"
              locale="ja-JP"
              size="is-medium"
              :min-date="minDate"
              :max-date="maxDate"
              :disabled="isNowButton()"
              @input="selectDate()"
              inline
            >
            </b-datepicker>
          </transition>
        </div>
      </div>
      <div v-else>
        <p class="message-title">時間をお選びください。{{inPeriod.every((item)=>item)?'':'(これ以降の日程は選択できません。)'}}</p>

        <button
          @click.once="returnCalendar()"
          class="button message-button slide-button-0"
          :disabled="isNowButton()"
          v-show="!parameter.is_hidden_calendar"
        >
          カレンダーに戻る
        </button>

        <template v-for="(m, index) in message.split('|')">
          <button
            :key="index"
            v-if="buttonCreate(m)!=='' && index!=0 && inPeriod[index-1]"
            class="button message-button"
            @click="calendarSubmit(buttonCreate(m), isBot, 0, index)"
            :class="{
                    'is-info'       : colorCreate(m) === 'Blue',
                    'is-warning'    : colorCreate(m) === 'Yellow',
                    'is-danger'     : colorCreate(m) === 'Red',
                    'slide-button-1': index === 1,
                    'slide-button-2': index === 2,
                    'slide-button-3': index === 3,
                    'slide-button-4': index === 4,
                    'slide-button-5': index === 5
                  }"
            :disabled="isNowButton()"
          >
            {{ buttonCreate(m) }}
          </button>
        </template>

        <button
          @click.once="nextDay(buttonCreate(message.split('|')[message.split('|').length - 1]))"
          class="button message-button slide-button-6"
          :disabled="isNowButton()"
          v-if="!isErrorRecommendSchedule && inPeriod.every((item)=>item)"
        >
          次の候補日時へ
        </button>

        <button
          v-if="!isErrorRecommendSchedule && displayPrevBtnFlg"
          @click.once="prevDay()"
          class="button message-button slide-button-7"
          :disabled="isNowButton()"
          >
          前の候補日時へ
        </button>

        <button
          class="button message-button slide-button-8"
          v-if="parameter.is_nothing_target_date"
          @click="noCalendarSubmit('希望する日程がない', isBot, 1)"
          :disabled="isNowButton()"
        >
          希望する日程がない
        </button>
      </div>
      <div v-if="isLoading">
        <span class="mdi mdi-spin mdi-loading mdi-48px" ></span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import hex2rgb from "@/functions/hex2rgb"
// 外部関数
import {
  autoColor,
  shadowStyle,
  colorCreate,
  buttonCreate,
  isNowButton
} from "@/functions/balloonFunc"

export default {
  name: "SelectParts",
  props: [
    'message',
    'speaker',
    'color',
    'lastIndex',
    'logIndex',
    'isBot',
    'isErrorRecommendSchedule',
    'preserveSuggestedSchedulesList',
    'isDemo',
    'companyHash',
    'displayPrevBtnFlg',
    'parameter',
    'makeCalendar',
    'state',
    'roboArguments'
  ],
  data () {
    return {
      date: null,
      minDate: null,
      maxDate: null,
      isCalenderDisplayed: false,
      inPeriod: null,
      isRedo: true,
      isLoading: false
    }
  },
  computed: {
    ...mapState('calendar', ['recommendDate']),
  },
  watch: {
    'parameter.absoluteMaxDate' () {
      this.$nextTick(() => {
        this.setDateLimit()
      })
    },
    'parameter.useAbsoluteLimit' () {
      this.$nextTick(() => {
        this.setDateLimit()
      })
    },
    'parameter.period' () {
      this.$nextTick(() => {
        this.setDateLimit()
      })
    }
  },
  created () {
    this.setDateLimit()
    setTimeout(() => {
      this.isCalenderDisplayed = true
    }, 500);
  },
  methods: {
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle (t) {
      return shadowStyle(t)
    },
    isNowButton () {
      if(this.isRedo) {
        return isNowButton(this.logIndex, this.lastIndex, this.speaker)
      } else {
        return true
      }
    },
    colorCreate (m) {
      return colorCreate(m, this.roboArguments)
    },
    buttonCreate (m) {
      return buttonCreate(m, this.roboArguments)
    },
    setDateLimit () {
      this.minDate = new Date()
      if (this.parameter.after) {
        this.minDate.setDate(this.minDate.getDate() + this.parameter.after - 1)
      } else {
        this.minDate.setDate(this.minDate.getDate() - 1)
      }

      let calculatedMaxDate = null

      // 既存のperiod制限
      if (this.parameter.period) {
        calculatedMaxDate = new Date()
        if (this.parameter.period % 1 === 0.5) {
          // 0.5刻みの場合（0.5, 1.5, 2.5...）: 整数月 + 14日
          const wholeMonths = Math.floor(this.parameter.period)
          calculatedMaxDate.setMonth(calculatedMaxDate.getMonth() + wholeMonths)
          calculatedMaxDate.setDate(calculatedMaxDate.getDate() + 14)
        } else {
          // 整数月の場合: 従来通り
          calculatedMaxDate.setMonth(calculatedMaxDate.getMonth() + this.parameter.period)
          calculatedMaxDate.setDate(calculatedMaxDate.getDate() - 1)
        }
        calculatedMaxDate.setHours(23)
        calculatedMaxDate.setMinutes(59)
      }

      // 新規：絶対日付制限
      if (this.parameter.useAbsoluteLimit && this.parameter.absoluteMaxDate) {
        try {
          const absoluteMaxDate = new Date(this.parameter.absoluteMaxDate)
          
          if (isNaN(absoluteMaxDate.getTime())) {
            console.warn('無効な絶対日付制限:', this.parameter.absoluteMaxDate)
            this.maxDate = calculatedMaxDate
            return
          }
          
          absoluteMaxDate.setHours(23, 59, 59, 999)

          if (!calculatedMaxDate || absoluteMaxDate < calculatedMaxDate) {
            this.maxDate = absoluteMaxDate
          } else {
            this.maxDate = calculatedMaxDate
          }
        } catch (error) {
          console.error('絶対日付制限の処理エラー:', error)
          this.maxDate = calculatedMaxDate
        }
      } else if (calculatedMaxDate) {
        this.maxDate = calculatedMaxDate
      }
      
      if (this.message.split('|').length!=1 && this.maxDate) {
        this.inPeriod = this.recommendDate.map((item) => new Date(item.start) < this.maxDate)
      } else {
        this.inPeriod = new Array(5).fill(true) // 5つの候補に対応        
      }
    },
    async calendarSubmit (m, isBot, btnIndex, calendarIdx) {
      console.log('=== calendarSubmit デバッグ開始 ===')
      console.log('選択された日時:', m)
      console.log('calendarIdx:', calendarIdx)
      console.log('parameter:', this.parameter)
      console.log('リマインド設定:', {
        is_remind: this.parameter && this.parameter.is_remind,
        remind_time: this.parameter && this.parameter.remind_time,
        remind_mail: this.parameter && this.parameter.remind_mail
      })
      
      const con = window.confirm(m + 'を選択します。よろしいでしょうか？')
      if (con) {
        this.isRedo = false
        this.isLoading = true
        
        console.log('makeCalendar呼び出し前')
        const [res, reason] = await this.makeCalendar(m, calendarIdx)
        console.log('makeCalendar結果:', { res, reason })
        
        if (res) {
          await this.$emit('submit', m, isBot, btnIndex)
          this.isLoading = false
        } else {
          console.error('makeCalendarエラー:', reason)
          if (reason == "Reserved") {
            alert('選択された日時は既に予約されています。再度日付を選択してください。')
            this.isLoading = false
            this.reload()
          } else {
            alert('エラーが発生いたしました。再度日付を選択してください。')
            this.isLoading = false
            this.isRedo = true
          }
        }
      } else {
        alert('キャンセルしました。')
        this.isLoading = false
        this.isRedo = true
      }
      console.log('=== calendarSubmit デバッグ終了 ===')
    },
    noCalendarSubmit (m, isBot, btnIndex) {
      const con = window.confirm('こちらを選択すると次へ進みます。よろしいでしょうか？')
      if (con) {
        this.$emit('submit', m, isBot, btnIndex)
      } else {
        alert('キャンセルしました。')
      }
    },
    submit (m, isBot, btnIndex) {
      this.$emit('submit', m, isBot, btnIndex)
    },
    selectDate () {
      this.$emit('nextDay', this.date)
    },
    returnCalendar () {
      this.$emit('returnCalendar')
    },
    nextDay (m) {
      this.$emit('nextDay')
    },
    prevDay () {
      this.$emit('prevDay')
    },
    reload() {
      this.$emit('reload')
    }
  },
};
</script>

<style lang="scss" scoped>
.message {
  text-align: left;
  padding: 12px 16px;  /* ①上下のpaddingを少し減らし、左右は維持 */
  width: auto;
  max-width: -webkit-fill-available;
  font-size: 95%;  /* ②fontsize up */
  border-radius: 18px;  /* ③より丸みを持たせる */
  line-height: 1.4;  /* ④読みやすさのために行間を調整 */
  transition: 0.7s;
  margin-bottom: 8px;  /* ⑤メッセージ間の間隔を追加 */
  .message-title {
    text-align: left;
    filter: none;
    font-size: 95%;
    word-wrap: break-word;
    margin-bottom: 8px;
    white-space: pre-wrap;
  }
  .message-button {
    display: flex;
    justify-content: left;
    filter: none;
    min-width: 100%; max-width: 100%;
    margin-top: 8px;
    margin-bottom: 10px;
    height: auto;
    overflow: initial;
    white-space: normal;
    text-overflow: ellipsis;
    font-size: 95%;
    text-align: left;
    border-radius: 8px;
  }
}
.my-box {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  margin-left: 10px;
}
.message-button {
  border: none;
  border-radius: 8px;
}
/* Animation */
@for $i from 0 through 8 {
  $enter-delay: 300ms;
  &.slide-button-#{$i} {
    // opacity: 1;
    animation-duration: #{200ms * ($i + 1)};
    animation-name: slide-in;
  }
}
@keyframes slide-in {
  0% {
    // opacity: 0;
    transform: scale(0) translateX(300px);
  }
  70% {
    // opacity: 0;
    transform: scale(0) translateX(300px);
  }
  100% {
    // opacity: 1;
    transform: scale(1) translateX(0);
  }
}

.v-fade-enter {
  opacity: 0;
}
.v-fade-enter-to {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/CalendarParts.vue